import { Modal, Input, Button } from "antd";
import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteRatingreviews } from "../../../../../../../redux/actions";
import './deletRatingModal.css'

const DeleteRatingsModal = ({ visible, setDelModalVisible, Ratings_data }) => {
  const { TextArea } = Input;
  const dispatch = useDispatch();

  const [reason, setReason] = React.useState();
  const [showError, setShowError] = React.useState(false);
  const [totalcount,setTotalCount] = useState(0);

  function onCancelHandler() {
    setDelModalVisible(false);
  }

  const onChange = (e) => {
    setShowError(false);
    setTotalCount(e.target.value.length)
    setReason(e.target.value);
  };

  function deleteRatings(params) {
    if (reason?.length > 0) {
      dispatch(
        deleteRatingreviews({
          DeleteReason: reason,
          Ratings_id: Ratings_data._id,
        })
      );
      setDelModalVisible(false);
    } else {
      setShowError(true);
    }
  }

  return (
    <Modal
      title={
        <h3>
          <b>Delete rating?</b>
        </h3>
      }
      visible={visible}
      onCancel={onCancelHandler}
      okText="Submit Reason"
      centered
      footer={[
        <button
          key="submit"
          onClick={deleteRatings}
          style={{
            backgroundColor: "#118936",
            color: "#fff",
            width: "250px",
            cursor: "pointer",
            height: "42px",
            border: "none",
            fontSize: "16px",
            fontWeight: "bold",
            borderRadius: "4px",
          }}
        >
          Submit reason
        </button>,
      ]}
    >
      <label>
        Please provide a reason for deleting this rating{" "}
        <b style={{ color: "red" }}>*</b>
      </label>
      <TextArea
        style={{ marginTop: "5px", border: showError && 'solid 1px #db2828', outline:'none' }}
        rows={5}
        autoSize={false}
        // showCount
        maxLength={5000}
        onChange={onChange}
        className='delet-reason-textarea'
      />
      {showError && (
        <label
          style={{
            color: "#db2828",
          }}
        >
          Please provide the reason
        </label>
      )}
      <div className="reasontotalCount">{totalcount} / 5000</div>
    </Modal>
  );
};
export default DeleteRatingsModal;
